import CoreSuggest from '@nrk/core-suggest/jsx';
import cn from 'classnames';
import React from 'react';

import { RowButton } from '@eika/button';

import ListEntry from './ListEntry';

interface SuggestionListProps {
    suggestList: {
        value: string;
        id?: string;
        ariaLabel?: string;
    }[];
    inputValue: string;
    coreSuggestId: string;
    onButtonSelect: (value: string) => void;
    showModal?: boolean;
    showOverlay?: boolean;
    setShowModal?: (showModal: boolean) => void;
    setShowOverlay?: (showOverlay: boolean) => void;
}

const SuggestionList = ({
    suggestList,
    inputValue,
    coreSuggestId,
    showModal,
    showOverlay,
    onButtonSelect,
    setShowModal,
    setShowOverlay,
}: SuggestionListProps): JSX.Element => {
    const onRowButtonClick = (element: string) => {
        onButtonSelect(element);
        if (setShowModal) setShowModal(false);
        if (setShowOverlay) setShowOverlay(false);
    };

    return (
        <CoreSuggest hidden={suggestList.length < 1} id={coreSuggestId} highlight="off">
            <ul
                className={cn('common--search-list', {
                    'search-list__overlay': showOverlay,
                    'search-list__modal': showModal,
                })}
            >
                {suggestList.map((element) => (
                    <li key={element.id || element.value}>
                        <RowButton type="button" onClick={() => onRowButtonClick(element.value)}>
                            <ListEntry elementValue={element.value} inputValue={inputValue} />
                        </RowButton>
                    </li>
                ))}
            </ul>
        </CoreSuggest>
    );
};

export default SuggestionList;
